import { Dispatch, createContext } from 'react';

export type MultiFactorAuthData = {
  email: string;
  password: string;
};

export type MfaState = {
  user: MultiFactorAuthData | null;
  setUser: Dispatch<MultiFactorAuthData | null>;
};

export const MfaContext = createContext<MfaState | null>(null);
